import { render, staticRenderFns } from "./SjlHotelProductList.vue?vue&type=template&id=eaf1afba&scoped=true"
import script from "./SjlHotelProductList.vue?vue&type=script&lang=js"
export * from "./SjlHotelProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eaf1afba",
  null
  
)

export default component.exports